
import { rateChatAiResponse } from '@/common/api/api.pleased';
import { AiMessageForUser } from '@/common/bot/types';
import { Component, Prop } from 'vue-property-decorator';
import Dialog, { ButtonType } from '@/components/Dialog.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import { Component as TsxComponent } from 'vue-tsx-support';
import { ThumbRate } from '@/common/api/models.pleased';

enum NegativeFeedbackReason {
  INCORRECT_INFORMATION_PROVIDED = 'incorrect_information',
  MAKING_UP_INFORMATION = 'making_up_information',
  OFF_TOPIC = 'off_topic',
  FORGOT_CONTEXT = 'forgot_context'
}

const NEGATIVE_FEEDBACK_REASONS = [
  {
    text: 'Incorrect information provided',
    value: NegativeFeedbackReason.INCORRECT_INFORMATION_PROVIDED,
  },
  {
    text: 'Making up information',
    value: NegativeFeedbackReason.MAKING_UP_INFORMATION,
  },
  { text: 'Off topic', value: NegativeFeedbackReason.OFF_TOPIC },
  { text: 'Forgot context', value: NegativeFeedbackReason.FORGOT_CONTEXT },
];

const SUB_REASON_DESCRIPTION_TEXT_MAP: {
  [key in NegativeFeedbackReason]?: string;
} = {
  [NegativeFeedbackReason.INCORRECT_INFORMATION_PROVIDED]:
    'Kindly select the articles from the list which may have impacted on incorrect response content.',
};

type NegativeAiFeedbackModalProps = {
  message: AiMessageForUser | null;
  onClose: () => void;
};

@Component({
  components: {
    Dialog,
    MultiSelect,
  },
})
export default class NegativeAiFeedbackModal extends TsxComponent<
  NegativeAiFeedbackModalProps
> {
  @Prop() message!: AiMessageForUser | null;

  readonly NEGATIVE_FEEDBACK_REASONS = NEGATIVE_FEEDBACK_REASONS;
  readonly SUB_REASON_DESCRIPTION_TEXT_MAP = SUB_REASON_DESCRIPTION_TEXT_MAP;

  showLoader = false;

  reasonComment = '';
  reason: NegativeFeedbackReason | null = null;
  subReasons: string[] = [];

  get showSubReasonsDropdown () {
    return this.reason && SUB_REASON_DESCRIPTION_TEXT_MAP[this.reason];
  }

  get subReasonsList () {
    const titlesFromReference = this.message?.aiResponse?.reference?.map(r => r.title) || [];
    // TODO: remove use of outdated reference_titles after some time
    const fallbackTitles = this.message?.aiResponse?.reference_titles || [];
    return titlesFromReference.length ? titlesFromReference : fallbackTitles;
  }

  get submitDisabled () {
    return (
      !this.message ||
      !this.reason ||
      !this.message.id ||
      !this.message.sessionId
    );
  }

  get buttons (): ButtonType[] {
    return [
      {
        name: 'Close',
        callback: this.close,
      },
      {
        name: 'Submit',
        class: ['primary'],
        callback: this.submit,
      },
    ];
  }

  async submit () {
    if (this.submitDisabled) {
      return;
    }

    try {
      this.showLoader = true;

      await rateChatAiResponse({
        sessionId: this.message!.sessionId!,
        messageId: this.message!.id!,
        isThumbUp: ThumbRate.DOWN,
        thumbDownReason: this.reason!,
        thumbDownSubReasons: this.subReasons,
        thumbDownReasonComment: this.reasonComment,
      });
    } catch (e) {
      console.error(e);
    } finally {
      this.showLoader = false;
    }

    this.close();
  }

  close () {
    this.$emit('close');
  }
}
